module.exports = __webpack_public_path__ + "img/pic_uk_02.4285ef2d.jpg";